import {
  AppActionTypes,
  AppState,
  LOG_IN,
  LOG_OUT,
  RESET_APP,
  SYNC_FAILURE,
  SYNC_INIT,
  SYNC_SUCCESS,
  TOGGLE_MENU
} from "./types";

const initialState: AppState = {
  loggedIn: false,
  isSyncing: false,
  successSyncing: false,
  errorSyncing: null,
  menuOpen: false
};

// maps state and action to next value of state
export default function appReducer(
  state = initialState,
  action: AppActionTypes
) {
  switch (action.type) {
    case LOG_IN:
      return {
        ...state,
        loggedIn: true
      };

    case LOG_OUT:
      return {
        ...state,
        loggedIn: false
      };

    case SYNC_INIT:
      return {
        ...state,
        isSyncing: true,
        successSyncing: false,
        errorSyncing: null
      };

    case SYNC_SUCCESS:
      return {
        ...state,
        isSyncing: false,
        successSyncing: true
      };

    case SYNC_FAILURE:
      return {
        ...state,
        isSyncing: false,
        errorSyncing: action.error
      };

    case TOGGLE_MENU:
      return {
        ...state,
        menuOpen: action.open
      };

    case RESET_APP:
      return initialState;

    default:
      return state;
  }
}
